/**
 * Add CSS rule (ex. color: red; ) for the current selector
 * as a stand-alone <style></style> block on the page.
 */

import { delay, remove } from 'lodash'

import onOptionChange from 'Functions/on-option-change'
import extractDataValue from 'Functions/extract-data-value'
import isCssRuleApplied from 'Functions/is-css-rule-applied'

window.stlst_legacy.insert_rule = function( selector, id, value, prefix, size ) {
	return addCssRule( {
		selector: selector,
		cssProperty: id,
		cssValue: value,
		cssUnit: prefix,
		mediaSize: size,
		pseudoClass: 'none',
	} )
}

/* ---------------------------------------------------- */
/* Appy CSS To theme for demo                           */
/* ---------------------------------------------------- */
export default function addCssRule( attrs ) {
	/* attrs:
		– selector,
		– cssProperty,
		– cssValue,
		– cssUnit,
		– mediaSize */

	let pseudoClass = 'none' === attrs.pseudoClass ? pseudoClass = '' : pseudoClass = ':' + attrs.pseudoClass,
		cssValue = attrs.cssValue,
		cssUnit = attrs.cssUnit.toString().trim().toLowerCase()

	const mainBody = jQuery( document.body ),
		selector = attrs.selector ? attrs.selector + pseudoClass : window.Stylist.cssSelectorCustom + pseudoClass,
		selectorFull = attrs.selectorFull,
		cssProperty = attrs.cssProperty.toString().toLowerCase(),
		element = window.stlst_legacy.get_selected_element(),
		stylistId = element.attr( 'data-stylist-id' ),
		mediaSize = attrs.mediaSize ? attrs.mediaSize : window.stlst_legacy.get_media_condition()

	// Stop early if not valid value provided.
	if ( 'string' !== typeof cssValue && 'number' !== typeof cssValue ) {
		return false;
	}

	if ( cssUnit == '.s' ) {
		cssUnit = 's';
	}

	if ( cssUnit.indexOf( 'px' ) != -1 ) {
		cssUnit = 'px';
	}

	// String in cssValue needs some cleaning and formating before can be used.
	cssValue = formatCssValue( cssProperty, cssValue )
	// Sometimes changing one value affects other controls.
	updateLinkedControls( {
		cssProperty: cssProperty,
		cssValue: cssValue,
		cssUnit: cssUnit,
		mediaSize: mediaSize,
	} )

	// also using in bottom.
	let duration;

	// If element has inline styles AND it isn't position:relative – use !important.
	/*
	Note: force_insert_rule not exists anymore replace it with regular addRule + !important
	if ( cssProperty != 'top' &&
		cssProperty != 'bottom' &&
		cssProperty != 'left' &&
		cssProperty != 'right' &&
		cssProperty != 'height' &&
		cssProperty != 'width' ) {
		// If has style attr.
		if ( window.stlst_legacy.isDefined( element.attr( "style" ) ) ) {
			// If style comes with more than one rule.
			if ( jQuery.trim(element.attr( "style" )).split( ";" ).length > 0) {
				let obj = element.attr( "style" ).split( ";" );

				for (let item in obj) {
					if ( jQuery.trim(obj[item].split( ":" )[0]) == cssProperty) {
						// Use important.
						if ( cssProperty != 'position' && cssProperty != 'animation-fill-mode' ) {
							window.stlst_legacy.force_insert_rule( selector, cssProperty, cssValue, cssUnit, mediaSize );
							return false;
						}
					}
				}
			} else if ( jQuery.trim( element.attr( "style" )).split( ":" )[0] == cssProperty ) {
				if ( cssProperty != 'position' && cssProperty != 'animation-fill-mode' ) {
					window.stlst_legacy.force_insert_rule( selector, cssProperty, cssValue, cssUnit, mediaSize );
					return false;
				}
			}
		}
	}

	// BACKGROUND COLOR: use !important if background-image defined.
	// Why???
	/*
	if ( 'background-color' === cssProperty ) {
		if (jQuery( "#stlst-background-image" ).val() != 'none' && jQuery( "#stlst-background-image" ).val() != '' ) {
			force_insert_rule(selector, cssProperty, cssValue, cssUnit, mediaSize );

			return false;
		}
	}
	*/

	// Responsive Settings
	const mediaBefore = window.stlst_legacy.create_media_query_before( cssProperty );
	// ex. value: @media (min-width:600px) {

	const mediaAfter = window.stlst_legacy.create_media_query_after();
	// ex. value: }

	// Delete same data.
	const exStyle = window.Stylist.iDocJQ.find( '[data-rule="' + cssProperty + '"][data-stylist-el="' + stylistId + '"][data-size-mode="' + mediaSize + '"]' );

	if ( exStyle.length > 0 ) {
		// exStyle.remove(); // for now just remove.

		if ( extractDataValue( exStyle.html() ) == cssValue + cssUnit ) {
			return false
		}

		exStyle.remove(); // else remove.
	}

	// Append style area.
	const stylesArea = window.Stylist.iDoc.getElementById( 'stlst-styles-area' )

	if ( null === stylesArea ) {
		window.Stylist.iBody.insertAdjacentHTML( 'beforeend', "<div id='stlst-styles-area'></div>" )
	}

	// No px em etc for this options.
	if ( cssProperty == 'z-index' || cssProperty == 'opacity' ||
		cssProperty == 'blur-filter' || cssProperty == 'grayscale-filter' ||
		cssProperty == 'brightness-filter' || cssProperty == 'contrast-filter' ||
		cssProperty == 'hue-rotate-filter' || cssProperty == 'saturate-filter' ||
		cssProperty == 'sepia-filter' || cssProperty.indexOf( "-transform" ) != -1 ) {
		if ( cssProperty != 'text-transform' && cssProperty != '-webkit-transform' ) {
			cssValue = window.stlst_legacy.number_filter( cssValue );
			cssUnit = '';
		}
	}

	// border-type is not a CSS Rule.
	if ( cssProperty == 'border-type' ) {
		return false;
	}

	// Checking.
	if ( cssValue == 'disable' ||
		false === cssValue ||
		cssValue == '' ||
		cssValue == 'undefined' ||
		cssValue === null ) {
		return false;
	}

	// New Value
	let current = cssValue + cssUnit;
	// Clean.
	current = current.replace( /\s+?!important/g, '' ).replace( /\;$/g, '' );
	// Delete basic CSS.
	window.stlst_legacy.delete_live_css();
	// Delete live css.
	window.Stylist.iDocJQ.find( ".stlst-live-css" ).remove(); // @todo: delete?

	if ( window.stlst_legacy.get_id( selector ) !== '' ) {
		const result = addStyleUntillWorks( {
			css: cssProperty,
			size: mediaSize,
			stylistId: stylistId,
			selectorFull: selectorFull,
			selector: selector,
			mediaBefore: mediaBefore,
			mediaAfter: mediaAfter,
			dpt: ':',
			current: current,
		} )

		return result
	}

	return { status: false, message: 'No selector.' }
}

const addStyleUntillWorks = ( styleData ) => {
	// Delete pseudo-class properties block so it doesn't affect
	// further function logics ex.: unwanted !important statements.
	const pseudoClasses = window.Stylist.iDoc.getElementById( 'stlst-css-data-pseudo-classes' )
	if ( null !== pseudoClasses ) {
		pseudoClasses.innerHTML = ''
	}

	// let styleAdded = false
	// Add temporary <style> to the page to see if selector is right
	// and we can add it into the editor CSS.
	addStyleBlock( styleData )

	const mainBody = jQuery( document.body )

	window.stlst_legacy.draw()

	if ( isCssRuleApplied( styleData.css, styleData.current ) ) {
		// Looks like our temporary CSS worked well, so we can add it now
		// into the Editor CSS.

		/**
		 * Before saving inserted CSS data into EditorCSS we need to clean it
		 * from modified .stlst-hover selector to the normal one.
		 */
		cleanPseudoClasses( styleData )
		onOptionChange( styleData )
		return { status: true, message: 'CSS Aplied ✅' }
	}

	removeStyleBlock( styleData )

	let fullSelector = styleData.selectorFull
	// Remove current selector part from the Full selector.
	fullSelector = fullSelector.replace( styleData.selector, '' )
	fullSelector = fullSelector.trim()

	let fullSelectorArray = fullSelector.split( ' ' )

	/*
	?Why deleting IDs from selector?
	if ( fullSelectorArray.length > 1 ) {
		remove( fullSelectorArray, function( n ) {
			return ! n.includes('#' );
		});

		fullSelectorArray = fullSelectorArray.reverse();
	}
	*/

	fullSelectorArray = fullSelectorArray.reverse();

	/**
	 * @todo: Make it work with selectors containing html or body tags and multiline selectors.
	 */
	if ( fullSelectorArray.length && fullSelectorArray[ 0 ] && ! styleData.selector.includes( fullSelectorArray[ 0 ] + ' ' ) ) {
		styleData.selector = fullSelectorArray[ 0 ] + ' ' + styleData.selector
	} else if ( ! styleData.current.includes( '!' ) ) {
		styleData.current = styleData.current + '!important'
	} else {
		return { status: false, message: 'Can not find the right selector.' }
	}

	// Update React App state if selector changed.
	if ( styleData.selector !== window.Stylist.selectedEl ) {
		window.Stylist.changeSelector( styleData.selector )
	}

	// Add more weight to the selector.
	// styleData.selector = styleData.selectorFull

	const added = addStyleUntillWorks( styleData )
	return added
}

const cleanPseudoClasses = ( styleData ) => {
	const pseudoClass = window.Stylist.cssCurrentPseudoClass

	// If any pseudo class is active remove temporary syle block
	// and insert it again with 'noPseudoClass' modifier.
	if ( pseudoClass != undefined && pseudoClass != 'none' ) {
		removeStyleBlock( styleData )
		addStyleBlock( styleData, false )
	}
}

/**
 * ADDING TEMPORARY CSS ON THE PAGE.
 * One <style> per control: font-size, color, etc...
 * Ex.: <div id="stlst-styles-area"><style....
 */

const addStyleBlock = ( styleData, addPseudoClasses = true ) => {
	let selectorWithPseudoClass = ''
	let selector = styleData.selector
	const styleBlockId = window.stlst_legacy.get_id( styleData.selector )

	const pseudoClass = window.Stylist.cssCurrentPseudoClass

	if ( addPseudoClasses ) {
		if ( pseudoClass === 'hover' ) {
			selectorWithPseudoClass = styleData.selector.replace( ':hover', '.stlst-hover' )
			selector = selector + ', ' + selectorWithPseudoClass
		} else if ( pseudoClass === 'active' ) {
			selectorWithPseudoClass = styleData.selector.replace( ':active', '.stlst-active' )
			selector = selector + ', ' + selectorWithPseudoClass
		} else if ( pseudoClass === 'focus' ) {
			selectorWithPseudoClass = styleData.selector.replace( ':focus', '.stlst-focus' )
			selector = selector + ', ' + selectorWithPseudoClass
		}
	}

	const stylesArea = window.Stylist.iDoc.getElementById( 'stlst-styles-area' )
	const styleValue = styleData.current

	// Wrap background image value into url()
	/* if ( 'background-image' === styleData.css ) {
		styleValue = 'url("' + styleData.current + '")'
	} */

	stylesArea.insertAdjacentHTML( 'beforeend',
		'<style data-test="5" data-rule="' + styleData.css +
		'" data-size-mode="' + styleData.size +
		'" data-stylist-el="' + styleData.stylistId +
		'" data-style="' + styleBlockId +
		'" class="stlst_current_styles">' +
			styleData.mediaBefore + '' + '' +
				selector + '{' +
					styleData.css + styleData.dpt + styleValue +
				'}' + '' +
			styleData.mediaAfter +
		'</style>' );
}

/**
 * Remove Style by parrametter.
 */

const removeStyleBlock = ( styleData ) => {
	window.Stylist.iDocJQ.find( '[data-rule="' + styleData.css + '"][data-stylist-el="' + styleData.stylistId + '"][data-size-mode="' + styleData.size + '"]' ).remove();
}

const formatCssValue = ( cssProperty, cssValue ) => {
	// Remove unwanted zeros after the dot.
	if ( cssValue.length ) {
		const r1 = /\.00$/;
		const r2 = /\.0$/;

		if ( r1.test( cssValue ) ) {
			cssValue = cssValue.replace( /\.00$/g, "" );
		}

		if ( r2.test( cssValue ) ) {
			cssValue = cssValue.replace( /\.0$/g, "" );
		}
	}

	// Value should be lowe case unless...
	if (	cssProperty != 'font-family' &&
			cssProperty != 'background-image' &&
			cssProperty != 'list-style-image' &&
			cssProperty != 'animation-name' &&
			cssProperty != 'animation-play' &&
			cssProperty != 'filter' &&
			cssProperty != '-webkit-filter' &&
			cssProperty != '-webkit-transform' ) {
		cssValue = cssValue.toString().toLowerCase();
	}

	// Convert keyword colors to hex values.
	if (	cssProperty == 'background-color' ||
			cssProperty == 'color' ||
			cssProperty == 'border-color' ||
			cssProperty == 'border-left-color' ||
			cssProperty == 'border-right-color' ||
			cssProperty == 'border-top-color' ||
			cssProperty == 'border-bottom-color' ) {
		const valueCheck = jQuery.trim( cssValue ).replace( "#", '' );

		if ( valueCheck == 'red' ) {
			cssValue = '#FF0000';
		} else if ( valueCheck == 'white' ) {
			cssValue = '#FFFFFF';
		} else if ( valueCheck == 'blue' ) {
			cssValue = '#0000FF';
		} else if ( valueCheck == 'orange' ) {
			cssValue = '#FFA500';
		} else if ( valueCheck == 'green' ) {
			cssValue = '#008000';
		} else if ( valueCheck == 'purple' ) {
			cssValue = '#800080';
		} else if ( valueCheck == 'pink' ) {
			cssValue = '#FFC0CB';
		} else if ( valueCheck == 'black' ) {
			cssValue = '#000000';
		} else if ( valueCheck == 'brown' ) {
			cssValue = '#A52A2A';
		} else if ( valueCheck == 'yellow' ) {
			cssValue = '#FFFF00';
		} else if ( valueCheck == 'gray' ) {
			cssValue = '#808080';
		}
	}

	// List Style image fix.
	if (	cssProperty == 'list-style-image' &&
			cssValue != 'disable' &&
			false !== cssValue &&
			cssValue != 'none' &&
			cssValue != '' ) {
		// If not has a url
		if ( cssValue.replace( /\s/g, "" ) == 'url()' ) {
			cssValue = 'disable';
		}
		// disable if URL is not valid
		if ( cssValue.indexOf( "//" ) == -1 ) {
			cssValue = 'disable';
		}
	}

	// Background image fix.
	if (	cssProperty == 'background-image' &&
			cssValue != 'disable' &&
			false !== cssValue &&
			cssValue != 'none' &&
			cssValue != '' ) {
		// If not has a url
		if ( cssValue.replace( /\s/g, "" ) == 'url()' ) {
			cssValue = 'disable';
		}
		// disable if not a gradient or non valid URL
		if ( cssValue.indexOf( "//" ) == -1 && cssValue.indexOf( "linear-gradient( " ) == -1 ) {
			cssValue = 'disable';
		}
	}

	cssValue = cssValue.trim()

	if ( cssValue[ cssValue.length - 1 ] === ',' ) {
		cssValue = cssValue.substring( 0, cssValue.length - 1 );
	}

	return cssValue
}

const updateLinkedControls = ( attrs ) => {
	const cssProperty = attrs.cssProperty,
		cssUnit = attrs.cssUnit,
		cssValue = attrs.cssValue,
		mediaSize = attrs.mediaSize

	// Checks min-height and min-width before applying height and width.
	/* if ( cssProperty == 'height' || cssProperty == 'width' ) {
		// minValue & minFormat
		const minVal = window.stlst_legacy.number_filter( jQuery( "#min-" + cssProperty + "-value" ).val() );
		const minFormat = jQuery( "#min-" + cssProperty + "-after" ).val();

		// if height is smaller than min-height, so update min height
		if ( parseFloat( cssValue ) < parseFloat( minVal ) && cssUnit == minFormat ) {
			// Insert min-height
			window.stlst_legacy.insert_rule( selector, 'min-' + cssProperty, cssValue, cssUnit, mediaSize );

			// Set default values
			setTimeout( function() {
				jQuery.each( [ 'min-' + cssProperty ], function( i, v ) {
					window.stlst_legacy.getDefaultValue( v );
				} );
			}, 50 );
		}
	} */
/* 
	// BORDERS

	// Set defaults
	if ( cssProperty == 'border-width' ) {
		// Set default values
		jQuery.each( [ 'border-top-width', 'border-left-width', 'border-right-width', 'border-bottom-width' ], function( i, v ) {
			window.stlst_legacy.getDefaultValue( v );
		} );
	}

	if ( cssProperty == 'border-color' ) {
		// Set default values
		jQuery.each( [ 'border-top-color', 'border-left-color', 'border-right-color', 'border-bottom-color' ], function( i, v ) {
			window.stlst_legacy.getDefaultValue( v );
		} );
	}

	if ( cssProperty == 'border-style' ) {
		// Set default values
		jQuery.each( [ 'border-top-style', 'border-left-style', 'border-right-style', 'border-bottom-style' ], function( i, v ) {
			window.stlst_legacy.getDefaultValue( v );
		} );
	}

	// When border-x-style change
	if (	cssProperty.indexOf( "border-" ) != -1 &&
			cssProperty.indexOf( "-style" ) != -1 &&
			cssProperty != 'border-style' ) {
		// Update default value for;
		window.stlst_legacy.getDefaultValue( 'border-style' )
	}

	// When border-x-style change
	if (	cssProperty.indexOf( "border-" ) != -1 &&
			cssProperty.indexOf( "-color" ) != -1 &&
			cssProperty != 'border-color' ) {
		// update default value for;
		window.stlst_legacy.getDefaultValue( "border-color" );
	}

	// When border-x-style change
	if (	cssProperty.indexOf( "border-" ) != -1 &&
			cssProperty.indexOf( "-width" ) != -1 &&
			cssProperty != 'border-width' ) {
		// update default value for;
		window.stlst_legacy.getDefaultValue( "border-width" );
	}

	// adding automatic relative.
	if (	cssProperty == 'top' ||
			cssProperty == 'bottom' ||
			cssProperty == 'left' ||
			cssProperty == 'right' ) {
		setTimeout( function() {
			if ( jQuery( "#position-static" ).parent().hasClass( "active" ) ||
				jQuery( "#position-relative" ).parent().hasClass( "active" ) ) {
				jQuery( "#position-relative" ).trigger( "click" );
			}
		}, 5 );
	} */
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/add-css-rule.js